import { makeStyles } from "@mui/styles";
import { createTheme } from "@mui/material/styles";

const theme = createTheme();

const useExamHeaderStyles = makeStyles(() => ({
  topNavBar: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#e0e0e0",
    overflow: "hidden",
    padding: "0rem 0.5rem",
    gap: theme.spacing(0.5),
    overflowX: "auto",
    "& .MuiButtonBase-root": {
      padding: "4px 0px !important",
    },
  },
  subjectWrapper: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#e0e0e0",
    gap: theme.spacing(1),
    position: "relative",
    scrollBehavior: "smooth",
    // top: "8px",
    overflowX: "auto",
    width: "100%",
    "&::-webkit-scrollbar": {
      width: "0px",
      display: "none",
    },
  },
  activeSubjectButton: {
    backgroundColor: "#38aae9 !important",
    color: "white !important",
    // borderRadius: "10px !important",
    textTransform: "none !important",
    display: "flex !important",
    alignItems: "center !important",
    gap: `${theme.spacing(1)} !important`,
    whiteSpace: "nowrap !important",
    // width: "40%",
    flexShrink: "0",
   
  },
  inactiveSubjectButton: {
    backgroundColor: "#cfcfcf !important",
    color: "black !important",
    // borderRadius: "10px !important",
    textTransform: "none !important",
    display: "flex !important",
    alignItems: "center !important",
    gap: `${theme.spacing(1)} !important`,
    whiteSpace: "nowrap !important",
    // width: "40%",
    flexShrink: "0",
  },
  sectionTimeContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: `${theme.spacing(0.5)} ${theme.spacing(2)}`,
    borderBottom: "1px solid #ddd",
    backgroundColor: "white",
  },
  wFull: {
    width: "calc(100vw - 90px)",
  },
  wHaf: {
    width: "calc(100vw - 395px)",
  },

  sectionTabsContainer: {
    display: "flex",
    overflowX: "auto",
    // borderBottom: "1px solid #ddd",

    scrollBehavior: "smooth",
    gap: "2px",
    margin: "0px 10px",
    "&::-webkit-scrollbar": {
      width: "0px",
      display: "none",
    },
  },
  activeSectionTab: {
    backgroundColor: "#4787c2 !important",
    color: "white !important",
    borderRadius: "0 !important",
    textTransform: "none !important",
    display: "flex !important",
    justifyContent: "center !important",
    alignItems: "center !important",
    gap: `${theme.spacing(1)} !important`,
    whiteSpace: "nowrap !important",
    flexShrink: "0",
    // width: "40%",
    textWrap: "nowrap",
  },
  inactiveSectionTab: {
    backgroundColor: "#cfcfcf !important",
    color: "black !important",
    borderRadius: "0 !important",
    textWrap: "nowrap",
    // width: "20%",
    textTransform: "none !important",
    display: "flex !important",
    justifyContent: "center !important",
    alignItems: "center !important",
    gap: `${theme.spacing(1)} !important`,
    whiteSpace: "nowrap !important",
    flexShrink: "0",
  },
  questionDetailsContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: `${theme.spacing(0.5)} ${theme.spacing(2)}`,
    flexWrap: "wrap",
    backgroundColor: "white",
    borderTop: "1px solid #ddd",
    borderBottom: "1px solid #ddd",
  },
  calculatorIcon: {
    color: "orange !important",
  },
  positiveMark: {
    color: "green",
  },
  negativeMark: {
    color: "red",
  },
  timeLeft: {
    color: "green",
  },
  arrowBtn: {
    background: "#cccccc",
    borderRadius: 0,
    padding: "5px 0px",
    color: "#505041",
    "& .MuiButtonBase-root": {
      padding: "0px !important",
    },
  },
}));

export default useExamHeaderStyles;
